import sample_01 from './esd.jpg';
import sample_02 from './esd2.jpg';

export const esdImpressions = {
    sample_01,
    sample_02,
};
